<script setup>
// Картка запису в архіві: кадр (або обкладинка ефіру, якщо запис закритий
// для глядача), тривалість, назва, дата й перегляди
const props = defineProps({
  record: { type: Object, required: true }
})

const config = useRuntimeConfig()
const media = (url) => (/^https?:/.test(url) ? url : `${config.public.apiBase}${url}`)

const image = computed(() => {
  if (props.record.thumbnail) return `${config.public.apiBase}${props.record.thumbnail}`
  if (props.record.cover) return media(props.record.cover)
  return ''
})

const badge = computed(() => archiveAccessOf(props.record.access).short)
</script>

<template>
  <NuxtLink
    :to="`/archive/${record.id}`"
    class="group flex flex-col gap-2"
  >
    <div class="relative bg-base-300 rounded-[12px] aspect-video overflow-hidden">
      <img
        v-if="image"
        :src="image"
        class="w-full h-full object-cover transition-[transform,filter] duration-300"
        :class="record.locked ? 'blur-md brightness-50 scale-110' : 'group-hover:scale-[1.03]'"
        loading="lazy"
        alt=""
      />
      <span
        v-if="record.locked"
        class="absolute inset-0 flex flex-col justify-center items-center gap-1 font-semibold text-sm text-white"
        ><span class="bg-black/60 px-2.5 py-1 rounded-full">🔒 {{ badge || 'Закрито' }}</span></span
      >
      <span
        v-else-if="badge"
        class="top-2 right-2 absolute px-1.5 py-0.5 rounded font-semibold text-[10px] uppercase"
        :class="record.access === 'admins' ? 'bg-error/90 text-error-content' : 'bg-accent/90 text-accent-content'"
        >{{ badge }}</span
      >
      <span class="right-2 bottom-2 absolute bg-black/70 px-1.5 py-0.5 rounded tabular-nums text-[11px] text-white">
        {{ formatClipTime(record.duration) }}
      </span>
      <span class="bottom-2 left-2 absolute bg-black/70 px-1.5 py-0.5 rounded tabular-nums text-[11px] text-white">
        {{ record.views }} перегл.
      </span>
    </div>

    <div class="min-w-0">
      <p class="font-semibold group-hover:text-primary text-sm line-clamp-2 transition-colors">
        {{ record.title }}
      </p>
      <p class="text-[12px] text-base-content/60">
        {{ formatArchiveDate(record.streamDate, false) }}
      </p>
    </div>
  </NuxtLink>
</template>
